// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2HDY2","calendarButtons":"ClockData_calendarButtons__RwN6v"};